// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectCountry } from 'src/app/store/runtime-variables/runtime-variables.selectors';

import { NbaParamResolver } from '../nba-param-resolver.interface';

import { NbaParamResolverId } from './nba-param-resolver-id.enum';

@Injectable()
export class CountryResolver implements NbaParamResolver {
  public readonly identifier: string = NbaParamResolverId.Country;

  public constructor(private readonly store: Store) {}

  /**
   * @returns country
   */
  public resolve$(): Observable<string> {
    return this.store.select(selectCountry);
  }
}
